import React from 'react';
import ReactDOM from 'react-dom/client';
import { KindeProvider } from '@kinde-oss/kinde-auth-react';
import App from './App.jsx';
import './index.css';

const kindeDomain = import.meta.env.VITE_KINDE_DOMAIN;
const kindeClientId = import.meta.env.VITE_KINDE_CLIENT_ID;
const kindeRedirectUri = import.meta.env.VITE_KINDE_REDIRECT_URI || window.location.origin;
const kindeLogoutRedirectUri = import.meta.env.VITE_KINDE_LOGOUT_REDIRECT_URI || window.location.origin;

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {kindeDomain && kindeClientId ? (
      <KindeProvider
        clientId={kindeClientId}
        domain={kindeDomain}
        redirectUri={kindeRedirectUri}
        logoutRedirectUri={kindeLogoutRedirectUri}
      >
        <App />
      </KindeProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
